/* eslint-disable object-curly-newline */
/* eslint-disable arrow-parens */
/* eslint-disable semi */
/* eslint-disable react/static-property-placement */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable max-len */
/* eslint-disable indent */
/* eslint-disable react/jsx-indent */
/* eslint-disable react/jsx-curly-spacing */
/* eslint-disable no-nested-ternary */
import React from 'react'
import * as H from 'history'
import Button from 'react-bootstrap/Button'
import { DashboardModel } from '../../../models/DashboardModel'
import { ApplicationController } from '../../../controllers/ApplicationController'
// import { MilestoneReportController } from '../../../controllers/MilestoneReportController'
// import { GrantAgreementController } from '../../../controllers/GrantAgreementController'
import { ISupportSpinner } from '../../../shared/Ajax'
import GrantAgreement from './GrantAgreement'
import ReportingRequirement from './ReportingRequirement'
import ApplicationSummary from './ApplicationSummary'
import { Loading } from '../../../shared/fields'
import { GlobalDataContext } from '../../../GlobalDataContext'

export interface Props {
    history: H.History
    location: H.Location
    id: string
    showGrantAgreement: boolean
    showMilestoneReport: boolean
}

export interface State {
    loading: boolean
    model: DashboardModel
    errorMsg : string
}

const ERROR_HAS_FUTURE_TIER = 'EMDG applications have now paused for this round as funding has been exhausted for previously available Tier categories. Applications for additional Tiers categories will be available for this round at a later date.';
const ERROR_ALL_TIERS_IN_PAST = 'EMDG applications have now closed for this round. You are no longer able to submit an application as funding has been exhausted across all tier categories.';

export default class ApplicationDetails extends React.Component<Props, State> implements ISupportSpinner {
    static contextType = GlobalDataContext
    context!: React.ContextType<typeof GlobalDataContext>
    ajax: ApplicationController

    constructor(props: Props) {
        super(props)
        this.ajax = new ApplicationController()

        this.state = {
            loading: false,
            model: null,
            errorMsg: '',
        }
    }

    async componentDidMount() {
        const { id, history, showGrantAgreement, showMilestoneReport } = this.props

        this.ajax.getDashBoardDetailByApplicationId(
            this,
            id,
            (model: DashboardModel) => {
                if (showGrantAgreement || showMilestoneReport) {
                    const applicationDetails = model?.dashboardDetailModels?.[0]
                    if (!applicationDetails.grantAgreementSummaryModel) {
                        history.push('/') // previously /dashboard-reform
                    } else {
                        this.setState({ model })
                    }
                } else {
                    this.setState({ model })
                }
            },
            (err) => {
                alert(err)
                history.push('/') // previously /dashboard-reform
            },
        )
    }

    handleDelete = () => {
        if (!confirm('Are you sure you want to delete this Application.')) {
            return
        }
        const applicationDetails = this.state.model?.dashboardDetailModels?.[0]
        const { applicationID } = applicationDetails
        const { history } = this.props
        this.ajax.delete(this, applicationID, () => {
            history.replace('/') // previously /dashboard-reform
        })
    }

    toggleSpinner(on: boolean, callback: { (): any }): void {
        this.setState({ loading: on }, callback)
    }

    downloadAgreement() {
        const { model } = this.state
        const claimIdentifier = model?.dashboardDetailModels?.[0]?.claimRandomIdentifier
        window.open(`/api/DocumentReform/downloadAgreement?claimIdentifier=${claimIdentifier}`, '_blank')
    }

    openFile() {
        const applicationDetails = this.state.model?.dashboardDetailModels?.[0]
        const { applicationID, applicationBlobID } = applicationDetails
        fetch(`/api/DocumentReform/download?applicationId=${applicationID}&blobid=${applicationBlobID}`, {
            method: 'GET',
            headers: { 'Content-Type': 'application/pdf' },
        })
            .then(res => res.blob())
            .then(response => {
                const file = new Blob([response], {
                    type: 'application/pdf',
                });
                const fileURL = URL.createObjectURL(file);
                window.open(fileURL);
            })
            .catch(error => {
                console.log(error);
            });
    }

    render() {
        const { loading, model } = this.state
        const { history, showGrantAgreement, id, showMilestoneReport } = this.props
        const applicationDetails = model?.dashboardDetailModels?.[0]

        if (!model || loading) return <Loading />

        const isDraft = applicationDetails.applicationStatus.toLowerCase() === 'draft'
        const disableAgreementButton = applicationDetails?.grantAgreementSummaryModel === null
        const agreementInvalidApplicationStatus = ['Unsuccessful', 'Draft', 'Submitted', 'Assessment in progress', 'Withdrawn', 'Withdrawn approved application']
        const hideAgreement = agreementInvalidApplicationStatus.includes(applicationDetails.applicationStatus)

        const showAddAgentDetails = model.financialYearName === '2026'
            && !model.isConsultant
            && !applicationDetails.hasAgentDetails
            && ['Submitted', 'Assessment in progress', 'Pending grant agreement', 'Grant agreement in draft', 'Grant agreement issued', 'Grant agreement accepted by Applicant','Grant agreement executed'].includes(applicationDetails.applicationStatus);
        console.log("Finacal year name :" + model.financialYearName)
        console.log("Is consultant:" + model.isConsultant)
        console.log("has agent details:" + applicationDetails.hasAgentDetails)
        console.log("app status:" + applicationDetails.applicationStatus)

        const disableAcceptDecline = !applicationDetails?.grantAgreementSummaryModel?.canAcceptOrDecline

        const tierDataCtx = this.context
        const currentDate = new Date();

        // Check if there is at least one object with openingDate <= now and (closingDate > now or closingDate is null)
        const hasOpenTier = tierDataCtx.tierSettingsArr.some(item => {
            const openingDate = item.openingDateUTC ? new Date(item.openingDateUTC) : null
            const closingDate = item.closingDateUTC ? new Date(item.closingDateUTC) : null

            // If openingDate is not null and it's in the past
            const isOpen = openingDate ? openingDate <= currentDate : false;

            // If closingDate is not null and it's in the future, or if it's null
            const isNotClosed = closingDate ? closingDate > currentDate : true;

            return isOpen && isNotClosed;
        })

        // Check if there is at least one item where current date is BEFORE openingDate
        const hasFutureTier = tierDataCtx.tierSettingsArr.some(item => {
            const openingDate = item.openingDate ? new Date(item.openingDate) : null;

            return openingDate ? currentDate < openingDate : false;
        });

        // Check if current date is AFTER closingDate for all items
        const allTiersClosed = tierDataCtx.tierSettingsArr.every(item => {
            const closingDate = item.closingDate ? new Date(item.closingDate) : null;

            return closingDate ? currentDate > closingDate : false;
        });

        const draftButtons = (
            <div className="col-md-9">
                <div className="float-right">
                    <Button className="emdg-btn" id="btnDelete" onClick={() => this.handleDelete()}>
                        Delete
                    </Button>
                    <Button
                        className="emdg-btn ml-2"
                        id="btnResume"
                        onClick={() => {
                            if (hasOpenTier) { // Call the function here
                                history.push(`/reform/${applicationDetails.applicationID}/applicant`);
                            } else if (hasFutureTier) {
                                this.setState({ errorMsg: ERROR_HAS_FUTURE_TIER });
                            } else if (allTiersClosed) {
                                this.setState({ errorMsg: ERROR_ALL_TIERS_IN_PAST });
                            } else {
                                this.setState({ errorMsg: 'The application cannot be resumed because there is no open Tier category.' });
                            }
                        }}
                    >
                        Resume
                    </Button>
                </div>
            </div>
        )

        const submittedButtons = (
            <div className="col-md-9">
                <div className="float-right">
                    {showAddAgentDetails && (
                        <Button
                            className="emdg-btn  mr-2"
                            id="btnAddAgentDetails"
                            onClick={() => (history.push(`/dashboard-reform/${applicationDetails.applicationID}/assignAgent`))}
                        >
                            Add agent details
                        </Button>
                    )}
                    <Button className="emdg-btn" id="btnViewApplication" onClick={() => this.openFile()}>
                        View submitted application
                    </Button>
                    {!hideAgreement && (
                        <Button
                            id="btnAgreement"
                            className="emdg-btn ml-2"
                            disabled={disableAgreementButton}
                            onClick={() => (disableAgreementButton
                                ? null
                                : history.push(`/dashboard-reform/${applicationDetails.applicationID}/summary/grantAgreement`))}
                        >
                            Agreement
                        </Button>
                    )}
                    { applicationDetails.applicationStatus.toLowerCase() === 'grant agreement executed' && (
                        <Button
                            id="btnViewMilestoneReport"
                            className="emdg-btn ml-2"
                            onClick={() => history.push(`/dashboard-reform/${applicationDetails.applicationID}/summary/milestoneReport`)}
                        >
                            Reports
                        </Button>
                    )}
                </div>
            </div>
        )

        return (
            <div className="container-fluid pt-3">
                <h2>My Applications</h2>
                <br />
                <ApplicationSummary
                    isConsultant={model.isConsultant}
                    isDraft={isDraft}
                    model={model}
                    applicationDetails={applicationDetails}
                />
                <br />
                {showGrantAgreement ? (
                    <>
                        <GrantAgreement
                            history={history}
                            grantAgreementSummary={applicationDetails.grantAgreementSummaryModel}
                            claimRandomIdentifier={applicationDetails.claimRandomIdentifier}
                        />
                        <div className="row">
                            <div className="col-sm-12 mb-1 d-flex justify-content-end">
                                <Button id="btnViewAgreement" className="emdg-btn emdg-btn--secondary mr-2" onClick={() => this.downloadAgreement()}>
                                    View
                                </Button>
                                {!model.isConsultant && (
                                    <>
                                        <Button className="emdg-btn emdg-btn--secondary mr-2" disabled={disableAcceptDecline} id="btnDeclineAgreement" onClick={() => history.push(`/dashboard-reform/${id}/grantAgreement/decline`)}>
                                            Decline
                                        </Button>
                                        <Button className="emdg-btn" disabled={disableAcceptDecline} id="btnAcceptAgreement" onClick={() => history.push(`/dashboard-reform/${id}/grantAgreement/accept`)}>
                                            Accept
                                        </Button>
                                    </>
                                )}
                            </div>
                        </div>
                    </>
                )
                    : (showMilestoneReport ? (
                        <ReportingRequirement
                            history={history}
                            model={model}
                            reportingRequirementSummary={applicationDetails.reportingRequirementSummaryModel}
                            claimRandomIdentifier={applicationDetails.claimRandomIdentifier}
                        />
                    ) : (
                        <>
                            <div className="row">
                                <div className="col-md-3">
                                    <Button className="emdg-btn emdg-btn--secondary" id="btnBack" onClick={() => history.goBack()}>
                                        Back
                                    </Button>
                                </div>
                                {isDraft ? draftButtons : submittedButtons}
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    {this.state.errorMsg && <div className="form-error float-right">{this.state.errorMsg}</div>}
                                </div>
                            </div>
                        </>
                    )
                    )}
            </div>
        )
    }
}
